// src/pages/courier/DistrictDetailModal.jsx
import React from 'react';
import { X, MapPin, Building2, Phone, Mail, AlertTriangle } from 'lucide-react';

const DistrictDetailModal = ({
  isOpen,
  onClose,
  districtName,
  stateName,
  eligibleBranches = [] // Array of branch items serving this district
}) => {
  if (!isOpen) return null;

  return (
    <div className="cm-modal-overlay">
      <div className="cm-modal-container cm-modal-md">
        <div className="cm-modal-header">
          <div className="cm-modal-title-group">
            <div className="cm-modal-icon-badge">
              <MapPin size={22} color="#8a6b32" />
            </div>
            <div>
              <h3 className="cm-modal-title">{districtName}</h3>
              <p className="cm-modal-subtitle">
                State: <strong>{stateName}</strong> &bull; Serving Courier Network
              </p>
            </div>
          </div>
          <button className="cm-btn-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="cm-modal-body">
          <div className="cm-summary-banner">
            <div className="cm-summary-banner-item">
              <span className="cm-summary-banner-label">Authorized Branches Serving</span>
              <span className="cm-summary-banner-val cm-val-accent">
                {eligibleBranches.length}
              </span>
            </div>
            <div className="cm-summary-banner-item">
              <span className="cm-summary-banner-label">Coverage Status</span>
              <span
                className={`cm-badge ${
                  eligibleBranches.length > 0 ? 'cm-badge-success' : 'cm-badge-inactive'
                }`}
              >
                {eligibleBranches.length > 0 ? 'Covered' : 'Uncovered'}
              </span>
            </div>
          </div>

          {eligibleBranches.length === 0 ? (
            <div className="cm-doc-empty">
              <AlertTriangle size={36} color="#f59e0b" />
              <p>No authorized courier branches are currently assigned to {districtName}.</p>
              <p className="cm-text-muted">
                To enable orders to be assigned for delivery in {districtName}, open an authorized branch
                and assign this service district.
              </p>
            </div>
          ) : (
            <div className="cm-district-branch-list">
              {eligibleBranches.map((item, idx) => (
                <div key={item.branchId || idx} className="cm-district-branch-card">
                  <div className="cm-district-branch-top">
                    <div className="cm-district-branch-title-group">
                      <div className="cm-courier-mini-badge">
                        {item.courierLogo ? (
                          <img src={item.courierLogo} alt="" />
                        ) : (
                          <Building2 size={16} color="#8a6b32" />
                        )}
                      </div>
                      <div>
                        <h4 className="cm-district-branch-name">{item.branchName}</h4>
                        <span className="cm-district-courier-name">
                          {item.courierName} ({item.branchCode || item.branchId})
                        </span>
                      </div>
                    </div>
                    <span
                      className={`cm-badge ${
                        item.active !== false ? 'cm-badge-success' : 'cm-badge-inactive'
                      }`}
                    >
                      {item.active !== false ? 'Active' : 'Inactive'}
                    </span>
                  </div>

                  <div className="cm-district-branch-contact-box">
                    <div className="cm-contact-row">
                      <Phone size={14} color="#8a6b32" />
                      <span>
                        <strong>Contact Number:</strong>{' '}
                        <a href={`tel:${item.contactNumber}`} className="cm-phone-link">
                          {item.contactNumber || 'Not specified'}
                        </a>
                      </span>
                    </div>
                    {item.alternateContactNumber && (
                      <div className="cm-contact-row">
                        <Phone size={14} color="#64748b" />
                        <span>
                          <strong>Alt Number:</strong> {item.alternateContactNumber}
                        </span>
                      </div>
                    )}
                    {item.contactPerson && (
                      <div className="cm-contact-row">
                        <span className="cm-contact-label">Contact Person:</span>
                        <span>{item.contactPerson}</span>
                      </div>
                    )}
                    {item.email && (
                      <div className="cm-contact-row">
                        <Mail size={14} color="#64748b" />
                        <span>{item.email}</span>
                      </div>
                    )}
                    {(item.address?.districtName || item.address?.city) && (
                      <div className="cm-contact-row">
                        <span className="cm-contact-label">Branch District & Location:</span>
                        <span>
                          <strong>{item.address?.districtName || item.address?.districtCode || item.address?.city}</strong>
                          {item.address?.city && item.address?.districtName && item.address.city.toLowerCase() !== item.address.districtName.toLowerCase() ? ` (${item.address.city})` : ''}
                          , {item.address?.stateName || item.address?.stateCode || ''}{' '}
                          {item.address?.pinCode ? `- ${item.address.pinCode}` : ''}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="cm-modal-footer">
          <button type="button" className="cm-btn-primary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DistrictDetailModal;
